<template>
  <AppCheckbox>
    <template #label>
      <span>
        {{ $tt(`priority.fast_processing`) }}: {{ $tt(`priority.wait_${urgency.speed}`) }}
        <PriceSpan :price="urgency.fee" operand="+" />
      </span>
      <BoltIcon end />
    </template>

    <template #message>
      <div class="ms-4">
        {{ $tt(`priority.checkbox_${urgency.speed}${urgency.isAppointment ? '_appointment' : ''}`) }}
      </div>
    </template>
  </AppCheckbox>
</template>

<script setup lang="ts">
import type { Urgency } from '~/types';

defineProps<{
  urgency: Urgency;
}>();
</script>